import { createTheme } from '@mui/material';
import * as themeComponents from './components';


export const theme = createTheme({
  typography: {
    ...themeComponents.typography
  },

  palette: {
    ...themeComponents.palette.palette
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: ({ theme }) => {
          return {
            borderRight: `1px solid ${theme.palette.secondary.dark}`
          };
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          '& .Mui-checkedthumb': {
            background: 'black'
          }
        }
      }
    },
    MuiTable: {
      styleOverrides: {
        root: ({ theme }) => {
          return {
            background: theme.palette.customGray.light,
            padding: '1rem',
            borderCollapse: 'separate',
            borderSpacing: '0 12px'
          };
        }
      }
    },
    MuiTableRow: {
      variants: [
        {
          props: {
            content: 'list'
          },
          style: () => {
            return {
              borderRadius: '1rem',
              background: '#fff'
            };
          }
        }
      ]
    },
    MuiTypography: {
      defaultProps: {
        whiteSpace: 'pre-wrap'
      }
    },

    MuiTableCell: {
      styleOverrides: {
        head: ({ theme }) => {
          return {
            ...theme.typography.tableHeader,
            textWrap: 'wrap',
            border: 'none',
            background: theme.palette.customGray.light
          };
        },
        body: ({ theme }) => {
          return {
            ...theme.typography.tableCellText,
            textTransform: 'none',
            textOverflow: 'ellipsis',
            overflowX: 'hidden',
            border: 0

          };
        }
      },
      variants: [
        {
          props: {
            variant: 'link'
          },
          style: ({ theme }) => ({
            ...theme.typography.tableCellLink,
            textTransform: 'none',
            textOverflow: 'ellipsis',
            textWrap: 'wrap',
            border: 0
          })
        },
        {
          props: {
            variant: 'firstRounded'
          },
          style: ({ theme }) => ({
            ...theme.typography.tableCellText,
            borderTopLeftRadius: '.75rem',
            borderBottomLeftRadius: '.75rem',
            textTransform: 'none',
            textOverflow: 'ellipsis',
            textWrap: 'wrap',
            border: 0
          })
        },
        {
          props: {
            variant: 'lastRounded'
          },
          style: ({ theme }) => ({
            ...theme.typography.tableCellText,
            borderTopRightRadius: '.75rem',
            borderBottomRightRadius: '.75rem',
            textTransform: 'none',
            textOverflow: 'ellipsis',
            textWrap: 'wrap',
            border: 0
          })
        }
      ]
    },
    MuiFormControl: {
      styleOverrides: {
        root: ({ theme }) => {
          return {
            ...theme.typography.formLabel,
            '& .MuiFormLabel-asterisk': {
              color: theme.palette.warning.main
            }
          };
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: () => {
          return {
            paddingTop: '0rem',
            paddingBottom: '0rem'
          };
        },

        icon: ({ theme }) => {
          return {
            stroke: theme.palette.primary.main
          };
        }
      }
    },

    MuiFormControlLabel: {
      styleOverrides: {
        root: ({ theme }) => {
          return {
            ...theme.typography.formLabel,
            '& .MuiFormLabel-asterisk': {
              color: theme.palette.warning.main
            }
          };
        },
        label: ({ theme }) => {
          return {
            ...theme.typography.formLabel,
            '& .MuiFormLabel-asterisk': {
              color: theme.palette.warning.main
            }
          };
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: ({ theme }) => {
          return {
            ...theme.typography.formLabel,
            '& .MuiFormLabel-asterisk': {
              color: theme.palette.warning.main
            }
          };
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: ({ theme }) => {
          return {
            ...theme.typography.formInput,
            padding: '.875rem',
            paddingTop: '0rem',
            paddingBottom: '0rem',
            marginTop: '.75rem',
            textTransform: 'none',
            background: theme.palette.customGray.light,
            border: `1px solid ${theme.palette.customGray.main}`,
            borderRadius: '.75rem',
            '&.MuiInputBase-root': {
              marginY: '.25rem'
            }
          };
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme }) => {
          return {
            display: 'flex',
            flexDirection: 'row',
            gap: '.25rem',
            borderRadius: '.75rem',
            padding: '.625rem',
            height: '1.5rem',
            color: '#FFF',
            ...theme.typography.pill
          };
        }
      },
      variants: [
        {
          props: {
            variant: 'filled'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.info.main

            };
          }
        },
        {
          props: {
            variant: 'purchased'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.success.dark

            };
          }
        },
        {
          props: {
            variant: 'toBeFilled'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.error.main

            };
          }
        },
        {
          props: {
            variant: 'complete'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.primary.main

            };
          }
        },
        {
          props: {
            variant: 'upcoming'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.info.main

            };
          }
        },
        {
          props: {
            variant: 'inProgress'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.warning.darker

            };
          }
        },
        {
          props: {
            variant: 'inApproval'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.purple.main

            };
          }
        },
        {
          props: {
            variant: 'delayed'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.error.main

            };
          }
        },
        {
          props: {
            variant: 'denied'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.error.main

            };
          }
        },
        {
          props: {
            variant: 'approved'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.customGray.dark

            };
          }
        },
        {
          props: {
            variant: 'rejected'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.error.main

            };
          }
        },
        {
          props: {
            variant: 'submitted'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: 'transparent',
              color: theme.palette.secondary.darker
            };
          }
        },
        {
          props: {
            variant: 'delivered'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.secondary.darker

            };
          }
        },
        {
          props: {
            variant: 'purchased'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.primary.dark

            };
          }
        },
        {
          props: {
            variant: 'approvedGreen'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.primary.main

            };
          }
        },
        {
          props: {
            variant: 'todo'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.info.dark

            };
          }
        },
        {
          props: {
            variant: 'upcomingOrange'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.warning.main

            };
          }
        },
        {
          props: {
            variant: 'overdue'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.error.main

            };
          }
        },
        {
          props: {
            variant: 'inApprovalGreen'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.success.main

            };
          }
        },
        {
          props: {
            variant: 'uploaded'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.customGray.dark

            };
          }
        },
        {
          props: {
            variant: 'empty'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: 'transparent',
              color: theme.palette.secondary.darker
            };
          }
        },
        {
          props: {
            variant: 'owner'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.primary.main

            };
          }
        },
        {
          props: {
            variant: 'subContractor'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.warning.darker

            };
          }
        },
        {
          props: {
            variant: 'superIntendent'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.info.main
            };
          }
        },
        {
          props: {
            variant: 'designer'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.purple.main
            };
          }
        },
        {
          props: {
            variant: 'dueInWeek'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.info.main

            };
          }
        },
        {
          props: {
            variant: 'new'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.purple.main

            };
          }
        },
        {
          props: {
            variant: 'rejectedGray'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.customGray.dark

            };
          }
        },
        {
          props: {
            variant: 'completedGray'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.customGray.dark

            };
          }
        },
        {
          props: {
            variant: 'inProgressBlue'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.info.main

            };
          }
        },
        {
          props: {
            variant: 'unfinished'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.error.main
            };
          }
        },
        {
          props: {
            variant: 'labelBadge'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.info.light,
              color: theme.palette.info.main,
              padding: '.25rem .25rem .25rem .25rem',
              borderRadius: '.25rem',
              height: '1.25rem'
            };
          }
        },
        {
          props: {
            variant: 'ownerBadge'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.primary.main,
              padding: '.25rem .25rem .25rem .25rem',
              borderRadius: '.25rem',
              height: '1.25rem'
            };
          }
        },
        {
          props: {
            variant: 'subContractorBadge'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.warning.darker,
              padding: '.25rem .25rem .25rem .25rem',
              borderRadius: '.25rem',
              height: '1.25rem'
            };
          }
        },
        {
          props: {
            variant: 'superIntendentBadge'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.info.main,
              padding: '.25rem .25rem .25rem .25rem',
              borderRadius: '.25rem',
              height: '1.25rem'
            };
          }
        },
        {
          props: {
            variant: 'designerBadge'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.primary.main,
              padding: '.25rem .25rem .25rem .25rem',

              height: '1.25rem'
            };
          }
        },
        {
          props: {
            variant: 'passed'
          },
          style: ({ theme }) => {
            return {
              backgroundColor: theme.palette.primary.main,
              height: '1.25rem'
            };
          }
        }


      ]
    },
    MuiDialog: {
      styleOverrides: {
        root: () => {
          return {
            margin: '0rem',
            padding: '0rem'

          };
        },
        paper: {
          paddingLeft: '1.25rem',
          paddingRight: '1.25rem',
          paddingBottom: '1.25rem',
          borderRadius: '1.25rem',
          // margin: '0rem',
          maxWidth: '99vw'
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: () => {
          return {
            borderRadius: '1rem'
          };
        }
      },
      variants: [
        {
          props: {
            variant: 'menu'
          },
          style: ({ theme }) => {
            return {
              borderRadius: '1rem',
              padding: '.5rem',
              border: `1px solid ${theme.palette.customGray.main}`,
              boxShadow: '0px 4px 30px 0px rgba(0, 0, 0, 0.10)'
            };
          }
        }
      ]
    },
    MuiButton: {
      styleOverrides: {
        contained: ({ theme }) => {
          return {
            ...theme.typography.button,
            paddingTop: '.75rem',
            paddingBottom: '.75rem',
            boxShadow: '0px 4px 20px 0px rgba(14, 18, 18, 0.06)',
            border: '1px solid rgba(255, 255, 255, 0.20)',
            borderRadius: '.75rem'
          };
        },
        outlined: ({ theme }) => {
          return {
            ...theme.typography.button,
            paddingTop: '.75rem',
            paddingBottom: '.75rem',
            borderRadius: '.75rem'
          };
        },
        containedPrimary: ({ theme }) => {
          return {
            // ...theme.typography.button,
            ...theme.typography.button,
            paddingTop: '.75rem',
            paddingBottom: '.75rem',
            boxShadow: '0px 4px 20px 0px rgba(14, 18, 18, 0.06)',
            border: '1px solid rgba(255, 255, 255, 0.20)',
            borderRadius: '.75rem'
          };
        },
        outlinedPrimary: ({ theme }) => {
          return {
            ...theme.typography.button,
            border: `1.5px solid ${theme.palette.secondary.dark}`,
            paddingTop: '.75rem',
            paddingBottom: '.75rem'
          };
        },
        containedSecondary: ({ theme }) => {
          return {
            ...theme.typography.button,
            color: theme.palette.secondary.darker
          };
        },
        outlinedSecondary: ({ theme }) => {
          return {
            ...theme.typography.button,
            color: theme.palette.secondary.darker,
            border: `1.5px solid ${theme.palette.secondary.dark}`,
            backgroundColor: 'transparent'
          };
        },
        containedWarning: ({ theme }) => {
          return {
            ...theme.typography.button,
            color: 'white'
          };
        },
        textSecondary: ({ theme }) => {
          return {
            ...theme.typography.button,
            color: theme.palette.secondary.darker,
            backgroundColor: 'transparent'
          };
        },
        outlinedError: ({ theme }) => {
          return {
            border: `1.5px solid ${theme.palette.secondary.dark}`
          };
        }
      }
    }
  }
});



